/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbUploadDocumentTaskItem } from './HchbUploadDocumentTaskItem';
import {
    HchbUploadDocumentTaskItemFromJSON,
    HchbUploadDocumentTaskItemFromJSONTyped,
    HchbUploadDocumentTaskItemToJSON,
    HchbUploadDocumentTaskItemToJSONTyped,
} from './HchbUploadDocumentTaskItem';

/**
 * 
 * @export
 * @interface HchbUploadDocumentsTaskBody
 */
export interface HchbUploadDocumentsTaskBody {
    /**
     * 
     */
    taskType: HchbUploadDocumentsTaskBodyTaskTypeEnum;
    /**
     * 
     */
    mrn: string;
    /**
     * 
     */
    attachmentType?: HchbUploadDocumentsTaskBodyAttachmentTypeEnum;
    /**
     * 
     */
    documents: Array<HchbUploadDocumentTaskItem>;
}


/**
 * @export
 */
export const HchbUploadDocumentsTaskBodyTaskTypeEnum = {
    UploadDocuments: 'upload_documents',
} as const;
export type HchbUploadDocumentsTaskBodyTaskTypeEnum = typeof HchbUploadDocumentsTaskBodyTaskTypeEnum[keyof typeof HchbUploadDocumentsTaskBodyTaskTypeEnum];

/**
 * @export
 */
export const HchbUploadDocumentsTaskBodyAttachmentTypeEnum = {
    Patient: 'patient',
    Episode: 'episode',
} as const;
export type HchbUploadDocumentsTaskBodyAttachmentTypeEnum = typeof HchbUploadDocumentsTaskBodyAttachmentTypeEnum[keyof typeof HchbUploadDocumentsTaskBodyAttachmentTypeEnum];


/**
 * Check if a given object implements the HchbUploadDocumentsTaskBody interface.
 */
export function instanceOfHchbUploadDocumentsTaskBody(value: object): value is HchbUploadDocumentsTaskBody {
    if (!('taskType' in value) || value['taskType'] === undefined) return false;
    if (value['taskType'] !== 'upload_documents') return false;
    
    if (!('mrn' in value) || value['mrn'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function HchbUploadDocumentsTaskBodyFromJSON(json: any): HchbUploadDocumentsTaskBody {
    return HchbUploadDocumentsTaskBodyFromJSONTyped(json, false);
}

export function HchbUploadDocumentsTaskBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbUploadDocumentsTaskBody {
    if (json == null) {
        return json;
    }
    return {
        
        'taskType': json['taskType'],
        'mrn': json['mrn'],
        'attachmentType': json['attachmentType'] == null ? undefined : json['attachmentType'],
        'documents': ((json['documents'] as Array<any>).map(HchbUploadDocumentTaskItemFromJSON)),
    };
}

export function HchbUploadDocumentsTaskBodyToJSON(json: any): HchbUploadDocumentsTaskBody {
    return HchbUploadDocumentsTaskBodyToJSONTyped(json, false);
}

export function HchbUploadDocumentsTaskBodyToJSONTyped(value?: HchbUploadDocumentsTaskBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskType': value['taskType'],
        'mrn': value['mrn'],
        'attachmentType': value['attachmentType'],
        'documents': ((value['documents'] as Array<any>).map(HchbUploadDocumentTaskItemToJSON)),
    };
}

